import { useEffect } from 'react';
import I18n from 'I18n';
export function usePageTitle(titleKey) {
  useEffect(() => {
    window.document.title = I18n.text(titleKey);
  }, [titleKey]);
}